import React from 'react';

export function Unknown() {
  return (
    <div>Page inconnue</div>
  )
}
